<template>
  <div class="container">
    <div class="overviewAndNav">
      <div class="header-container"><h3>Overzicht {{ this.currentlySelectedMonth | toMonthNameWithYear }}</h3></div>
    </div>

    <div class="row d-flex justify-content-between align-items-center">
      <div class="row button-next-month">
        <button
            class="btn-basic btn-teal"
            style="width: 50px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
            @click="previousMonth">
          <svg
              width="1em" height="1em"
              viewBox="0 0 16 16" class="bi bi-chevron-left"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          </svg>
        </button>
        <button class="btn-basic" disabled
            style="border-radius: 0; opacity: 1; background-color: #72d3e3">
          {{ this.currentlySelectedMonth | toMonthNameWithYear }}
        </button>
        <button
            class="btn-basic btn-teal"
            style="width: 50px; border-top-left-radius: 0; border-bottom-left-radius: 0;"
            @click="nextMonth">
          <svg
              width="1em" height="1em"
              viewBox="0 0 16 16" class="bi bi-chevron-right"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>
      </div>
      <select class="form-select" v-model="invoiceFiltering">
        <option :key="mode" v-for="mode in getFilterModes()">{{ mode }}</option>
      </select>
    </div>
    <div class="table-responsive">
    <table class="table">
      <thead class="thead-dark">
      <tr>
        <th>Datum</th>
        <th>Factuurnummer</th>
        <th>Naam bedrijf</th>
        <th>Naam werknemer</th>
        <th>Totaal</th>
        <th>Status</th>
        <th></th>
      </tr>
      </thead>
      <tr v-for="(invoice, index) in filteredInvoices()" :key="index">
        <td>{{ invoice.invoiceDate }}</td>
        <td>{{ invoice.invoiceNr }}/</td>
        <td>{{ invoice.customerBillingDto.organisationName }}</td>
        <td>{{ invoice.subject }}</td>
        <td>€{{ invoice.totalVATIncluded }}</td>
        <td>{{ invoice.status }}</td>
        <td>
          <button class="btn-basic btn-outline-pulse" @click="showDetailed(invoice)">Meer details</button>
        </td>
      </tr>
    </table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import FilterModes, {InvoiceStatusList} from "@/constants/FilterConstants";

export default {
  name: "AdminInvoiceViewComponent",
  components: {},
  data: () => ({
    invoiceFiltering: FilterModes.CREATED,
  }),
  computed: {
    ...mapGetters({
      currentlySelectedMonth: "time/currentlySelectedMonth",
      invoices: "administrationInvoice/invoices",
      selectedInvoice: "administrationInvoice/selectedInvoice"
    }),
  },
  created() {
    this.initializeCurrentlySelectedMonth();
    this.fetchInvoices();
  },
  methods: {
    ...mapActions("administrationInvoice", ["fetchInvoices",'fetchInvoiceById']),
    ...mapMutations("administrationInvoice", ['setSelectedInvoice']),
    ...mapMutations({
      initializeCurrentlySelectedMonth: "administrationInvoice/initializeCurrentlySelectedMonth",
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth"
    }),
    getFilterModes() {
      return InvoiceStatusList;
    },
    filteredInvoices() {
      if (this.invoiceFiltering === FilterModes.CREATED) {
        return this.invoices.filter(invoice => invoice.status === "CREATED");
      } else if (this.invoiceFiltering === FilterModes.CONFIRMED) {
        return this.invoices.filter(invoice => invoice.status === "CONFIRMED");
      } else if (this.invoiceFiltering === FilterModes.CREDIT_NOTED) {
        return this.invoices.filter(invoice => invoice.status === "CREDIT_NOTED");
      } else if (this.invoiceFiltering === FilterModes.MAILED) {
        return this.invoices.filter(invoice => invoice.status === "MAILED");
      } else {
        return this.invoices;
      }
    },
    showDetailed(invoice) {
      this.fetchInvoiceById(invoice.id);
      this.$router.push({path: "/admin/viewinvoicedetail"});
    },
    previousMonth() {
      this.subtractMonth();
      this.fetchNewData();
    },
    nextMonth() {
      this.addMonth();
      this.fetchNewData();
    },
    fetchNewData() {
      this.fetchInvoices();
    }
  }
};
</script>

<style scoped>
.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

tbody tr {
  cursor: pointer;
}

tbody tr {
  display: flex;
  align-items: center;
}

select {
  width: 150px;
  height: 30px;
}

.button-next-month {
  margin-bottom: 10px;
  margin-top: 5px;
  margin-left: 20px;
}
</style>